var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-canvas-container" }, [
      _c("div", { staticClass: "side-menu-close" }, [
        _c("i", { staticClass: "la la-times" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-canvas-nav" }, [
        _c(
          "div",
          {
            staticClass: "section-tab section-tab-2 text-center pt-4 pb-3 pl-4",
          },
          [
            _c(
              "ul",
              {
                staticClass: "nav nav-tabs",
                attrs: { id: "myTab", role: "tablist" },
              },
              [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link  active",
                      attrs: {
                        id: "account-tab",
                        "data-toggle": "tab",
                        href: "#account",
                        role: "tab",
                        "aria-controls": "account",
                        "aria-selected": "true",
                      },
                    },
                    [_vm._v("\n            Account\n          ")]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-canvas-nav-content" }, [
        _c(
          "div",
          { staticClass: "tab-content", attrs: { id: "myTabContent" } },
          [
            _c(
              "div",
              {
                staticClass: "tab-pane fade show active",
                attrs: {
                  id: "account",
                  role: "tabpanel",
                  "aria-labelledby": "account-tab",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "user-action-wrap user-sidebar-panel" },
                  [
                    _c("div", { staticClass: "notification-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          attrs: { href: "user-dashboard-profile.html" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("div", {
                                staticClass:
                                  "avatar avatar-sm flex-shrink-0 mr-2",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "font-size-14 font-weight-bold",
                                },
                                [_vm._v("Admin")]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-group drop-reveal-list user-drop-reveal-list",
                        },
                        [
                          _c("div", { staticClass: "section-block" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "list-group-item list-group-item-action",
                              attrs: { href: "/logout" },
                            },
                            [
                              _c("div", { staticClass: "msg-body" }, [
                                _c("div", { staticClass: "msg-content" }, [
                                  _c("h3", { staticClass: "title" }, [
                                    _c("i", {
                                      staticClass: "la la-power-off mr-2",
                                    }),
                                    _vm._v("Logout"),
                                  ]),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }